import { GridColDef } from '@mui/x-data-grid-pro';
import { DisplayMoney, DisplayNumber } from '@price-for-profit/data-grid';
import { DisplayDate } from 'shared/components';
import { BelowMarginFloorColumn } from './below-margin-floor-column';
import { DisplayProductNumber } from './product-number-column';

export const columns: GridColDef[] = [
  {
    headerName: 'Commodity',
    field: 'commodity',
    width: 130,
  },
  {
    headerName: 'Description',
    field: 'description',
    width: 130,
  },
  {
    headerName: 'Product Number',
    field: 'productNumber',
    renderCell: DisplayProductNumber,
    width: 130,
  },
  {
    headerName: 'Last Best Price',
    field: 'lastBestPrice',
    type: 'number',
    width: 130,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Last Best Price Margin',
    field: 'lastBestPriceMargin',
    width: 160,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Model Cost',
    field: 'modelCost',
    type: 'number',
    width: 100,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Revised Cost',
    field: 'revisedCost',
    type: 'number',
    editable: true,
    cellClassName: 'drive-app-wps--cell--editable',
    renderCell: DisplayMoney(),
    width: 100,
  },
  {
    headerName: 'Rec Best Price',
    field: 'recommendedBestPrice',
    type: 'number',
    width: 130,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Rec Margin per Case',
    field: 'recommendedBestPriceMarginPerCase',
    type: 'number',
    width: 160,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Rev. Future Best Price',
    field: 'revisedBestPrice',
    type: 'number',
    editable: true,
    cellClassName: 'drive-app-wps--cell--editable',
    renderCell: DisplayMoney(),
    width: 160,
  },
  {
    headerName: 'Rev. Best Price Margin',
    field: 'revisedBestPriceMarginPerCase',
    width: 160,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Rev. Spot Best Price',
    field: 'revisedSpotBestPrice',
    type: 'number',
    editable: true,
    cellClassName: 'drive-app-wps--cell--editable',
    renderCell: DisplayMoney(),
    width: 150,
  },
  {
    headerName: 'Avg Freight Surcharge',
    field: 'avgFreightSurcharge',
    type: 'number',
    renderCell: DisplayMoney(),
    width: 160,
  },
  {
    headerName: 'Best Price + Freight',
    field: 'bestPricePlusFreight',
    renderCell: DisplayMoney(),
    width: 160,
  },
  {
    headerName: 'PL5 + Freight',
    field: 'priceLevelFivePlusFreight',
    renderCell: DisplayMoney(),
    width: 100,
  },
  {
    headerName: 'Below Margin Floor',
    field: 'belowMarginFloor',
    renderCell: BelowMarginFloorColumn,
    width: 150,
  },
  {
    headerName: 'Last Week Cases Sold',
    field: 'lastWeekCasesSold',
    renderCell: DisplayNumber(),
    width: 160,
  },
  {
    headerName: 'PO Cost',
    field: 'purchaseOrderCost',
    type: 'number',
    width: 100,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'PO Qty',
    field: 'purchaseOrderQuantity',
    type: 'number',
    width: 100,
  },
  {
    headerName: 'Inventory Cost',
    field: 'inventoryCost',
    type: 'number',
    width: 130,
    renderCell: DisplayMoney(),
  },
  {
    headerName: 'Inventory Qty',
    field: 'inventoryQuantity',
    type: 'number',
    width: 100,
  },
  {
    headerName: 'Buyer',
    field: 'buyer',
    width: 100,
  },
  {
    headerName: 'Review Status',
    field: 'status',
    width: 130,
  },
  {
    headerName: 'Date Modified',
    field: 'updatedDate',
    width: 160,
    renderCell: DisplayDate,
  },
];
